import React, {useState} from 'react'
import CartTable2 from '../../../../components/AdminTable/CartTale2'


function MultipleVatReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "SubTotal",
      accessorKey: "SubTotal",
    },
    {
      header: "Vat",
      accessorKey: "Vat",
    },
    {
      header: "Total Sale",
      accessorKey: "TotalSale",
    },
    
  ]);
  const [data] = useState([
   
  ]);
  const [buttonDataa] = useState([
   {
    buttonText: "Submit"
   }
  ]);

  const [selectButton] = useState([
    {
      placeholder: "Vat"
    },
  
  ])

  return (
    <main>
     <CartTable2
     data={data}
     columns={columns}
     heading={"Multiple Vat Report"}
     buttonDataa={buttonDataa}
     selectButton={selectButton}
     /> 
     
    </main>
  )
}

export default MultipleVatReport
